var map = {
	"./IMAGE.png": 65114,
	"./PDF.png": 44079,
	"./PPT.png": 2558,
	"./RAR.png": 38502,
	"./TXT.png": 18519,
	"./Word.png": 13752,
	"./Zip.png": 47424,
	"./cut-off-rule.png": 31494,
	"./icon-line.png": 13843,
	"./mp3.png": 67100,
	"./mp4.png": 59542,
	"./other.png": 27858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40519;